import Link from 'next/link';
import PrimaryButton from '@/Component/Common/Forms/PrimaryButton';
import Modal from '@/Component/Common/Modal';

const CampaignRestrictModal = (props) => {
    const { restrictModalOpen, setRestrictModalOpen, translations, setApproveModalOpen } = props;
    return (
        <Modal modalSize="w-1/1 md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/6" modal={restrictModalOpen} setModal={setRestrictModalOpen}>
            <div className='flex flex-col gap-2.5'>
                <p className=''>
                    <div dangerouslySetInnerHTML={{ __html: translations?.thisCampaignIsCurrentlyRestrictedMessage }} />
                </p>
                <div className="flex items-center justify-center sm:gap-3.5 gap-1.5 w-full mt-3">
                    <PrimaryButton buttonType="button" customClass="!w-full !max-w-48" onClick={() => setRestrictModalOpen(false)}>{translations?.ok}</PrimaryButton>
                </div>
            </div>
        </Modal>
    )
}

export default CampaignRestrictModal
